import { Switch } from "./ui/switch";

const OPTIONS = [[3, "Light"], [6, "Standard"], [9, "Rich"]];

export const StyleMatchControl = ({ enabled, onEnabled, count, onChange, disabled, error }) => (
  <section className="rounded-2xl border border-border bg-card/60 p-4 space-y-4" data-testid="library-style-settings">
    <div className="flex items-center justify-between gap-3">
      <label htmlFor="use-library" className="text-sm font-semibold">Use library</label>
      <Switch id="use-library" data-testid="use-library-switch" checked={enabled} onCheckedChange={onEnabled} disabled={disabled} />
    </div>
    {enabled && <fieldset disabled={disabled} data-testid="style-match-control">
      <legend className="text-xs font-mono2 uppercase tracking-widest text-muted-foreground mb-3">Style match · optional</legend>
      <div className="grid grid-cols-3 gap-2">
        {OPTIONS.map(([value, label]) => <label key={value} className="relative cursor-pointer min-w-0">
          <input type="radio" name="style-match" value={value} checked={count === value} onChange={() => onChange(value)}
            data-testid={`style-match-${label.toLowerCase()}`} className="peer sr-only" />
          <span className="flex flex-col items-center gap-1 rounded-xl border border-border px-1 py-3 text-xs font-semibold transition-colors hover:bg-muted peer-checked:border-accent peer-checked:bg-accent/10 peer-checked:text-accent peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-disabled:opacity-50">
            {label}<span className="font-mono2 font-normal">{value} refs</span>
          </span>
        </label>)}
      </div>
      <p data-testid="style-match-help" className="text-xs text-muted-foreground mt-3">Sculpt style from our ducks. Likeness, outfit and colours from your photo. Includes a classic duck when available; fewer refs if the library is small.</p>
    </fieldset>}
    {error && <p role="status" data-testid="style-match-error" className="text-xs text-destructive">{error}</p>}
  </section>
);
